import { render, staticRenderFns } from "./permit-application.vue?vue&type=template&id=20f361b8&"
import script from "./permit-application.vue?vue&type=script&lang=js&"
export * from "./permit-application.vue?vue&type=script&lang=js&"
import style0 from "./permit-application.vue?vue&type=style&index=0&lang=css&"
import style1 from "./permit-application.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports